import classNames from 'classnames';
import createMarkup from 'helpers/createMarkup';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faBan, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import ImagenPerfil from '../../components/common/ImagenPerfil';

const Notification = ({
    flush,
    notification,
    setIdLead,
    setShowModalSeguimientoLead,
    hayNotificacionesNoLeidas
    //setIsModalOpen
}) => {
    const { token } = useToken();
    const navigate = useNavigate();

    let objAction = {};
    try {
        objAction = notification?.vJsonAction ? JSON.parse(notification.vJsonAction) : {};
    } catch {
        objAction = {};
    }

    const cuerpoRaw = notification?.vCuerpo || '';
    const cuerpoLower = cuerpoRaw.toLowerCase();
    const tituloLower = (notification?.vTitulo || '').toLowerCase();
    const actionTipo = (objAction?.tipoCancelacion || '').toUpperCase();

    // Detección de notificación en proceso de cancelación (programada)
    const isCancelacionProgramada =
        actionTipo === 'PROGRAMADA' ||
        tituloLower.includes('cancelación programada') ||
        tituloLower.includes('cancelacion programada') ||
        cuerpoLower.includes('programó la cancelación') ||
        cuerpoLower.includes('programo la cancelacion') ||
        cuerpoLower.includes('cancelación programada') ||
        cuerpoLower.includes('cancelacion programada');

    // Detección de notificación cancelada por completo (definitiva/finalizada)
    const isCancelacionCompleta =
        !isCancelacionProgramada && (
            actionTipo === 'DEFINITIVA' ||
            tituloLower.includes('cancelación de suscripción') ||
            tituloLower.includes('cancelacion de suscripcion') ||
            cuerpoLower.includes('se canceló la suscripción') ||
            cuerpoLower.includes('se cancelo la suscripcion') ||
            cuerpoLower.includes('se canceló por completo') ||
            cuerpoLower.includes('se cancelo por completo') ||
            cuerpoLower.includes('concluyó su período pagado') ||
            cuerpoLower.includes('concluyo su periodo pagado')
        );

    // Ocultar cualquier texto "Motivo: ..." del cuerpo de la notificación
    const cleanCuerpo = cuerpoRaw.replace(/\.?\s*Motivo\s*:\s*[^<.]*(?=<|$|\.)/gi, '');

    // Maneja el click para abrir el modal de seguimiento de lead
    const clickToModalSeguimientoLead = (idLead) => {
        setIdLead(idLead);
        setShowModalSeguimientoLead(true);
        notification.bFueMostrado = true;
        marcarNotificacionComoMostrada(notification.idNotificacion);
    };

    const clickToUrl = () => {
        notification.bFueMostrado = true;
        marcarNotificacionComoMostrada(notification.idNotificacion);
        if (objAction?.detalles?.vUrl) {
            navigate(objAction.detalles.vUrl);
        }
    };

    const marcarNotificacionComoMostrada = async (idNotificacion) => {
        var jDataSend = {};
        jDataSend.idNotificacion = idNotificacion;

        const response = await fetch("/api/account/MarcarNotificacionComoMostrada/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response && response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1 && hayNotificacionesNoLeidas) {
                hayNotificacionesNoLeidas();
            }
        }
    };

    const handleClick = () => {
        if (objAction.TypeAction == 1) {
            if (objAction.detalles?.idModalType == 1) {
                if (objAction.detalles?.data?.idLicense) {
                    notification.bFueMostrado = true;
                    marcarNotificacionComoMostrada(notification.idNotificacion);
                    navigate(`/licencias/detalle/${objAction.detalles.data.idLicense}`);
                } else if (objAction.detalles?.data?.idLead) {
                    clickToModalSeguimientoLead(objAction.detalles.data.idLead);
                }
            }
        }
        if (objAction.TypeAction == 2 || objAction.TypeAction == 3) {
            clickToUrl();
        }
    };

    // Estilos de tarjeta con acento de color característico
    let itemStyle = { border: 'none', cursor: 'pointer', transition: 'all 0.15s ease' };
    if (isCancelacionProgramada) {
        itemStyle = {
            ...itemStyle,
            borderLeft: '4px solid #f59e0b',
            backgroundColor: notification.bFueMostrado ? '#fffdf7' : '#fffbeb',
            padding: '9px 12px'
        };
    } else if (isCancelacionCompleta) {
        itemStyle = {
            ...itemStyle,
            borderLeft: '4px solid #ef4444',
            backgroundColor: notification.bFueMostrado ? '#fffafa' : '#fef2f2',
            padding: '9px 12px'
        };
    }

    return (
        <div
            className={classNames(
                'notification p-0',
                {
                    'notification-unread': !notification.bFueMostrado && !isCancelacionProgramada && !isCancelacionCompleta,
                    'notification-flush': flush
                }
            )}
            style={itemStyle}
            onClick={handleClick}
        >
            <div className="notification-avatar me-3 justify-items-center">
                {isCancelacionProgramada ? (
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                        style={{
                            width: '38px',
                            height: '38px',
                            minWidth: '38px',
                            backgroundColor: '#fef3c7',
                            color: '#d97706',
                            border: '1px solid #fde68a'
                        }}
                    >
                        <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: '1.05rem' }} />
                    </div>
                ) : isCancelacionCompleta ? (
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                        style={{
                            width: '38px',
                            height: '38px',
                            minWidth: '38px',
                            backgroundColor: '#fee2e2',
                            color: '#dc2626',
                            border: '1px solid #fecaca'
                        }}
                    >
                        <FontAwesomeIcon icon={faBan} style={{ fontSize: '1.05rem' }} />
                    </div>
                ) : (
                    <ImagenPerfil idUsuario={notification.idUsuarioSource} />
                )}
            </div>

            <div className="notification-body flex-grow-1">
                {isCancelacionProgramada && (
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <span
                            className="badge px-2 py-1"
                            style={{
                                backgroundColor: '#fef3c7',
                                color: '#92400e',
                                border: '1px solid #fde68a',
                                fontSize: '10px',
                                fontWeight: 700,
                                letterSpacing: '0.4px',
                                textTransform: 'uppercase'
                            }}
                        >
                            <FontAwesomeIcon icon={faClock} className="me-1" />
                            Cancelación Programada
                        </span>
                        <span
                            style={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: '#f59e0b',
                                display: 'inline-block'
                            }}
                            title="Cancelación en proceso"
                        />
                    </div>
                )}

                {isCancelacionCompleta && (
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <span
                            className="badge px-2 py-1"
                            style={{
                                backgroundColor: '#fee2e2',
                                color: '#991b1b',
                                border: '1px solid #fecaca',
                                fontSize: '10px',
                                fontWeight: 700,
                                letterSpacing: '0.4px',
                                textTransform: 'uppercase'
                            }}
                        >
                            <FontAwesomeIcon icon={faBan} className="me-1" />
                            Suscripción Cancelada
                        </span>
                        <span
                            style={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: '#ef4444',
                                display: 'inline-block'
                            }}
                            title="Cancelada definitivamente"
                        />
                    </div>
                )}

                <p className="mb-1 text-dark" style={{ fontSize: '0.85rem', lineHeight: '1.3' }} dangerouslySetInnerHTML={createMarkup(cleanCuerpo)} />
                <span className="notification-time text-muted" style={{ fontSize: '0.75rem' }}>
                    {notification.time}
                </span>
            </div>
        </div>
    );
};

Notification.propTypes = {
    flush: PropTypes.bool,
    notification: PropTypes.object,
    setIdLead: PropTypes.func,
    setShowModalSeguimientoLead: PropTypes.func,
    hayNotificacionesNoLeidas: PropTypes.func
    //setIsModalOpen: PropTypes.func,
};

export default Notification;
